export default __webpack_public_path__ + "static/media/bag.3d98b84d.svg";